import { c as _c } from "react/compiler-runtime";
import withStyles from '@mui/styles/withStyles';
import styles from './styles';
const IllustrationSkeleton = t0 => {
  const $ = _c(7);
  const {
    classes: t1,
    style: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const classes = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const style = t4;
  let t5;
  if ($[4] !== classes.illustration || $[5] !== style) {
    t5 = <div style={style} className={classes.illustration} />;
    $[4] = classes.illustration;
    $[5] = style;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default withStyles(styles)(IllustrationSkeleton);